import styled from 'styled-components';

import { gridBase } from '@yoweb/ui/styles/utils';

const ColumnGrid = styled.div`
  ${gridBase};
`;

export default ColumnGrid;
